<template>
  <div class="container_j" @click.stop="inEdit.state ? '' : $emit('quadratinoClicked')">
    <!-- PULSANTE AGGIUNTIVO INIZIO -->
    <div
      @click.stop="$emit('addListinoButtonClicked')"
      v-if="selettore.tastoAggiuntivo && (!selettore.mantieniAggiuntivo || selettore.mantieniAggiuntivo === ricambio.id)"
      :class="{ mantieni : selettore.mantieniAggiuntivo === ricambio.id || ricambio.regola_specifica === true}"
      class="tasto_aggiuntivo_quadratino "
    >
      <i v-if="!ricambio.regola_specifica" class="fas fa-plus" />
      <i v-if="ricambio.regola_specifica" class="fas fa-minus" />
    </div>
    <!-- PULSANTE AGGIUNTIVO FINE -->
    {{ spegniUltimo(ricambio.id) }}
    <div class="caption">
      <div v-if="selettore.mostra_pulsantini" class="pulsantini">
        <i
          class="fas fa-pencil-alt"
          v-if="inEdit.title ==='' && ricambio.fonte === 'interno' "
          title="edit"
          @click.stop="inEdit.state = true ,inEdit.title= ricambio.id,inEdit.value=ricambio.value"
        /> &nbsp;
        <i
          class="fas fa-undo-alt"
          v-if="inEdit.title === ricambio.id"
          title="annulla"
          @click.stop="inEdit.state = false ,inEdit.title = '',inEdit.value=''"
        /> &nbsp;
        <i
          class="fas fa-save"
          title="salva"
          v-if="inEdit.title === ricambio.id"
          @click.stop="inEdit.state = false ,inEdit.title= '',updateElement(ricambio,inEdit.value)"
        />&nbsp;
        <i class="fas fa-trash" @click.stop="removeElement(ricambio)" />
      </div>
      <span
        v-if="selettore.mostra_sconto && ricambio.l_prezzo"
        class="tag_prezzo"
      >{{ ricambio.l_prezzo }} €</span>

      <span
        v-if="ricambio.prezzo>0 && selettore.mostra_prezzo && ricambio.parent === 'ricambi'"
        class="tag_prezzo"
      >{{ calcolaPrezzo(ricambio) }}</span>
    </div>
    <div
      @keyup.enter="!nelCarrello(ricambio) ? addToCart(ricambio) : removeFromCart(ricambio)"
      class="h-100 d-flex justify-content-center no-focus"
      @click="!nelCarrello(ricambio) ? addToCart(ricambio) : removeFromCart(ricambio), quadratino_selezionato = index,selettore.step_selezionato = ricambio"
    >
      <div class="d-flex align-items-center" style="height:calc(100% - 2.2vh);">
        <div class="d-flex flex-column align-items-center" style="position:relative; ">
        <div style="position:relative;">
          <imageLoader
            :uploadTask="uploadTask"
            :options="imageSize"
            @imgClicked="inEdit.state ? $refs.imgChange.click() : ''"
            :imgInfo="ricambio"
            style=" width: auto; height: 4.3vw; margin: 0 auto;"
          />
          <input
            :ref="true ? 'imgChange' : null"
            id="file_upload"
            type="file"
            style="display:none;"
            @change="images = $event.target.files, changeImg(ricambio)"
          />
          <div v-if="inEdit.title !== ricambio.id " class="titolo_ricambio">{{ ricambio['value'] }}</div>
          <div v-else>
            <input
              class="titolo_ricambio"
              @keyup.enter="updateElement(ricambio,inEdit.value)"
              @click.stop
              v-if="uploadTask.state_ !== 'running'"
              v-model="inEdit.value"
            />
            <progressBar v-else :progress="progress"></progressBar>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { db } from "@/components/Firebase_Conn";
import { storage } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import Vue from "vue";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";

// <selettoreQuadratino  :items="items" :ricambio="ricambio" :selettore="selettore" :inEdit="inEdit"></selettoreQuadratino>
const progressBar = () => import("@/components/common/progressBar");
Vue.component("progressBar", progressBar);

export default {
  name: "SelettoreQuadratino",
  props: ["index", "items", "selettore", "ricambio"],
  data() {
    return {
      expired: false,
      message: "Caricando...",
      // vedi pulsantini modifica/salva titolo quadratini.
      inEdit: {
        state: false,
        title: "",
        value: ""
      },
      images: [],
      imageSize: {
        width: "auto",
        height: "4.3vw"
      }
    };
  },
  computed: {
    ...mapGetters({
      uploadTask: "selettoreStates/uploadTask",
      pointer: "selettoreStates/pointer"
    }),
    progress() {
      if (this.uploadTask.blob_) {
        return (
          (this.uploadTask.transferred_ / this.uploadTask.blob_.size_) * 100
        );
      }
    }
  },
  methods: {
    addToCart(elemento) {
      // if (elemento.parent === "ricambi")
      // this.costruttore.elementi=this.ricambi
    },
    removeFromCart() {},
    // aggiorna e crea alias
    updateElement(item, value) {
      var payload = { item: item , value : value }
      this.$store
        .dispatch("selettoreStates/updateElement", payload)
        .then(() => {
          this.inEdit.title = "";
          console.log("Element updated.");
        });
    },
    nelCarrello(obj) {
      if (this.items) {
        const mapIds = this.items.map(foo => foo["id"]);
        if (mapIds.includes(obj.id)) {
          return true;
        }
      }
      // return ids.includes(obj.id);*/
    },
    changeImg(ricambio) {
      console.table("id_immagine" + ricambio.id);
      this.$store
        .dispatch("selettoreStates/loadImg", {
          ricambio: ricambio,
          file: this.images[0]
        })
        .then(response => {
          console.log("Loading in corso");
        })
        .catch(err => {
          console.log(err);
        });
    },
    itemClicked(ricambio) {
      this.$emit("itemClicked", ricambio);
    },
    removeElement(ricambio) {
      this.$store
        .dispatch("selettoreStates/removeElement", ricambio)
        .then(() => {
          console.log("Rimosso");
        });
    },
    spegniUltimo(id) {
      let self = this;
      let delay = setTimeout(function() {
        self.appena_salvato = "";
      }, 3000);
    },
    calcolaPrezzo(ricambio) {
      let risultato;
      risultato = parseFloat(ricambio.prezzo);
      if (risultato > 0) {
        if (ricambio.l_prezzo) risultato += parseFloat(ricambio.l_prezzo);
        return risultato + " €";
      } else return null;
    }
  },
  mounted() {
    var self = this;
    setTimeout(function() {
      self.message = "Problemi caricamento.Riprova.";
      setTimeout(function() {
        self.expired = true;
      }, 5000);
    }, 5000);
  },
  watch: {
    uploadTask() {
      this.uploadTask.then(snapshot => {
        snapshot.ref.getDownloadURL().then(url => {
          this.imageSrc = url;
        });
      });
    }
  }
};
</script>

<style scoped>
.ultimo_inserito {
  border: solid 3px #a5dc86 !important;
}

.tasto_aggiuntivo_quadratino {
  opacity: 0;
  position: absolute;
  top: -3px;
  right: -4px;
  z-index: 1;
  background-color: #fbcf00;
  width: 3.2vh;
  height: 3.2vh;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: solid 2px white;
  color: white;
  -webkit-box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.2);
  text-align: center;
  line-height: 2.8vh;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  z-index: 99999;
}

.sele:hover .tasto_aggiuntivo_quadratino {
  opacity: 1 !important;
  /*  15px per titolo_ricambio  */
}

.mantieni {
  opacity: 1 !important;
}

.pulsantini {
  position: absolute;
  right: 10px;
  color: #e5e5e5;
}

.pulsantini i {
  cursor: pointer;
}

.caption {
  text-align: center;
  line-height: 2.3vh;
  background-color: #f9f9f9;
  width: 100%;
  height: 2.5vh;
  position: relative;
  right: 0px;
  padding-top: 1px;
  display: block;
  color: #444444;
  font-size: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.tag_prezzo {
  background-color: #afafaf;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

.tag_prezzo_list {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  background-color: orange;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

.titolo_ricambio {
  height: 15px;
  width: 120px;
  margin: 0 auto;
  font-size: 11px;
  text-align: center;
  text-transform: capitalize;
  color: #969696;
  margin-top: 0px !important;
}
</style>
